export const packingSuppliesLevelTwo = [
    {
        "parentCategoryId": "packing_n_supplies",
        "level": 2,
        "name": "Packing Materials",
        "categoryId": "packing_materials"
    }

]
